import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "copyIcon", "checkIcon"]

  copy() {
    const pre = this.element.querySelector("pre")
    if (!pre) return

    // After #addLineNumbers runs, code lives in .code-line spans.
    // Blank lines were replaced with \u00a0 — restore them to empty strings.
    const lineSpans = pre.querySelectorAll(".code-line")
    const code = lineSpans.length
      ? [...lineSpans].map(l => l.textContent.replace(/\u00a0/g, "")).join("\n")
      : pre.textContent

    navigator.clipboard.writeText(code).then(() => this.#showFeedback())
  }

  #showFeedback() {
    const btn = this.buttonTarget
    btn.disabled = true
    btn.setAttribute("aria-label", "Copied!")
    btn.setAttribute("title", "Copied!")
    this.copyIconTarget.style.display = "none"
    this.checkIconTarget.style.display = ""

    setTimeout(() => {
      btn.disabled = false
      btn.setAttribute("aria-label", "Copy code")
      btn.setAttribute("title", "Copy code")
      this.copyIconTarget.style.display = ""
      this.checkIconTarget.style.display = "none"
    }, 2000)
  }
}
